export interface DeclineTutorBookingChangeRequest {
  reason?: string;
}

export interface ProposeTutorBookingChangeRequest {
  reason?: string;
  newStartTime: string;
  /** When true and booking is pending, accepting the proposal also confirms the booking. */
  autoAcceptTutorBooking?: boolean;
}

export interface CancelTutorBookingChangeRequest {
  reason?: string;
}

export enum TutorBookingChangeStatus {
  PENDING_REPLY = 'PENDING_REPLY',
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  CANCELLED = 'CANCELLED',
}

export type TutorBookingChangeProposedBy = 'USER' | 'HOST' | 'ADMIN' | 'TUTOR';

export interface TutorBookingChangeProposal {
  id: string;
  tutorBookingId?: string;
  proposedBy?: TutorBookingChangeProposedBy;
  proposalReason?: string | null;
  oldStartTime: string;
  newStartTime: string;
  status: TutorBookingChangeStatus;
  replyComment?: string | null;
  repliedAt?: string | null;
  cancelComment?: string | null;
  canceledAt?: string | null;
  active?: boolean;
  createdAt?: string | null;
  autoAcceptTutorBooking?: boolean;
}
